/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_itinerary__max_steps_reached = /** @type {(inputs: {}) => string} */ () => {
	return `Max. Etappenzahl erreicht`
};

const en_itinerary__max_steps_reached = /** @type {(inputs: {}) => string} */ () => {
	return `Maximum number of steps reached`
};

const es_itinerary__max_steps_reached = /** @type {(inputs: {}) => string} */ () => {
	return `Número máximo de escalas alcanzado`
};

const fr_itinerary__max_steps_reached = /** @type {(inputs: {}) => string} */ () => {
	return `Nombre maximum d'étapes atteint`
};

const it_itinerary__max_steps_reached = /** @type {(inputs: {}) => string} */ () => {
	return `Numero massimo di tappe raggiunte`
};

const nl_itinerary__max_steps_reached = /** @type {(inputs: {}) => string} */ () => {
	return `Maximum aantal tussenstops bereikt`
};

const pt_itinerary__max_steps_reached = /** @type {(inputs: {}) => string} */ () => {
	return `Número máximo de etapas atingido`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__max_steps_reached = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.itinerary__max_steps_reached(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("itinerary__max_steps_reached", locale)
	if (locale === "de") return de_itinerary__max_steps_reached(inputs)
	if (locale === "en") return en_itinerary__max_steps_reached(inputs)
	if (locale === "es") return es_itinerary__max_steps_reached(inputs)
	if (locale === "fr") return fr_itinerary__max_steps_reached(inputs)
	if (locale === "it") return it_itinerary__max_steps_reached(inputs)
	if (locale === "nl") return nl_itinerary__max_steps_reached(inputs)
	return pt_itinerary__max_steps_reached(inputs)
};